import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=d8b4b8a8&"
import script from "./Layout.vue?vue&type=script&lang=ts&"
export * from "./Layout.vue?vue&type=script&lang=ts&"
import style0 from "./Layout.vue?vue&type=style&index=0&id=d8b4b8a8&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8b4b8a8')) {
      api.createRecord('d8b4b8a8', component.options)
    } else {
      api.reload('d8b4b8a8', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=d8b4b8a8&", function () {
      api.rerender('d8b4b8a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/layout/Layout.vue"
export default component.exports